import { Module } from 'vuex';
import { IRootState } from '@/store';
import { ICurrencyState } from './currency.types';
import { ICurrencyData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ICurrencyState = {
  version: 1,
  currencies: [] as ICurrencyData[]
};

const namespaced = true;

export const currencyNew: Module<ICurrencyState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
